<template>
    <div class="relative bottom-12 right-0 md:right-4 inline-flex items-center mb-6 select-none">
        <!-- Bloc texte avec fond doré -->
        <div :class="['bg-gold px-6 py-2  rounded-l', className]">
            <h2 class="text-2xl font-semibold text-background m-0">
                <slot></slot>
            </h2>
        </div>

        <!-- SVG penché à droite, qui prolonge le fond -->
        <svg width="50" height="48" viewBox="0 0 40 48" fill="none" xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true" class="-m-2 fill-gold stroke-gold">
            <path d="M0 0 L5 0 L30 48 L0 48 Z" />
        </svg>
    </div>
</template>

<script setup>

</script>